export const REGIONS = [];

export default REGIONS;
